import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * The softphone number field lives here (not in SoftphonePanel local state) so
 * it SURVIVES the panel unmounting/remounting — which happens when a call ends
 * and the wrap-up overlay swaps the view, or when the panel docks/floats. Local
 * useState was reset to '' on every such remount, making the typed number
 * "disappear" after a call.
 */
interface DialInputState {
  value: string;
  /** המספר האחרון שחויג — נשמר כשהשדה מתנקה, לחיוג חוזר. */
  lastDialed: string;
  set: (v: string) => void;
  append: (s: string) => void;
  backspace: () => void;
  /** מנקה את השדה ושומר את מה שהיה בו כ-lastDialed. */
  clear: () => void;
  /** מחזיר את המספר האחרון לשדה. ריק אם אין. */
  recallLast: () => string;
}

export const useDialInput = create<DialInputState>()(
  persist(
    (set, get) => ({
      value: '',
      lastDialed: '',
      set: (v) => set({ value: v }),
      append: (s) => set((st) => ({ value: st.value + s })),
      backspace: () => set((st) => ({ value: st.value.slice(0, -1) })),
      // השדה מתנקה בסוף שיחה, אבל המספר נשמר — לחיצה על "חייג" בשדה ריק
      // מחזירה אותו, כך שחיוג חוזר הוא שתי לחיצות ולא הקלדה מחדש.
      clear: () => set((st) => ({ value: '', lastDialed: st.value || st.lastDialed })),
      recallLast: () => {
        const last = get().lastDialed;
        if (last) set({ value: last });

        return last;
      },
    }),
    { name: 'merkaziya-dial-input' },
  ),
);
